import { useState, useEffect } from "react";
import { getAllAximaDomains } from '../../../http/aximaHttp/AximaDomainHttp'
import PageTitle from '../../../components/PageTitle'
import Div from "../../../components/Div";
// import { BsThreeDotsVertical } from 'react-icons/bs'
// import { Dropdown } from 'react-bootstrap'
import EditDomainModal from "../../../components/Axima/EditDomainModal";
import Input from "../../../components/Input";
import { Pagination, Stack } from "@mui/material";
import AximaDomainDetailModal from "../../../components/Axima/AximaDomainDetailModal";
import FormButton from "../../../components/FormButton";
import AddAximaDomainModal from "../../../components/Axima/AddAximaDomainModal"
import { role } from "../../../util/validation";
import Select from "../../../components/Select";
import { deployment_status } from "../../../util/enum";

export default function AddAximaDomain() {

  const [domainList, setDomainList] = useState([]);
  // const [isAscending, setIsAscending] = useState(true);
  const [modalClicked, handleModalClicked] = useState(false)
  const [initailDomainList, setInitialDomainList] = useState([])
  const [addDomain, setAddDomain] = useState(false);
  const [subscriptionList, setSubscriptionList] = useState(false)

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = domainList.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil(domainList.length / itemsPerPage);

  // Change page
  const paginate = (event, value) => {
    setCurrentPage(value);
  };

  const getDomains = async () => {
    const response = await getAllAximaDomains()
    setDomainList(response.domains)
    setInitialDomainList(response.domains)
  }

  const status = deployment_status.deployment_status.map((status) =>
    <option key={status.id}
      name={status.id}
      value={status.id}>
      {status.value}</option>
  )

  useEffect(() => {

    getDomains()

  }, []);

  function handleSearchDomain(event) {

    const search = event.target.value;
    const filteredList = initailDomainList.filter((domain) => {

      if (domain && domain.domain_name) {

        return domain.domain_name.toLowerCase().includes(search.toLowerCase());
      }
      else {
        return false
      }
    });

    setDomainList(filteredList);

  }


  // const renderActionButtons = (subscription_id, domain_name) => {
  //   return (
  //     <div className="d-flex justify-content-center">
  //       <Dropdown>
  //         <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
  //           <BsThreeDotsVertical />
  //         </Dropdown.Toggle>

  //         <Dropdown.Menu>
  //           <Dropdown.Item onClick={() => handleModalClicked({ 'subscription_id': subscription_id, domain_name: domain_name })} >
  //             Edit
  //           </Dropdown.Item>
  //         </Dropdown.Menu>

  //       </Dropdown>
  //     </div>
  //   );
  // };



  async function handleDomainClick(domain_id) {
    setSubscriptionList(domain_id)

  }

  // const sortData = () => {
  //     const sorted = [...initailDomainList].sort((a, b) => {
  //       const dateA = new Date(a.timestamp);
  //       const dateB = new Date(b.timestamp);
  //       return isAscending ? dateA - dateB : dateB - dateA;
  //     });
  //     setDomainList(sorted)
  //     // setSortedData(sorted);
  //     setIsAscending(!isAscending);
  //   };

  function handleUpdateStatus(event) {

  }



  return (
    <>
      {addDomain ? <AddAximaDomainModal show={true.toString()} open handleClicked={setAddDomain} /> : null}
      {subscriptionList ? <AximaDomainDetailModal show={true.toString()} domain_id={subscriptionList} open handleClicked={setSubscriptionList} /> : null}
      {modalClicked ? <EditDomainModal updateState={getDomains} show={true.toString()} open domain_name={modalClicked} handleClicked={handleModalClicked} /> : null}
      <PageTitle title='All Axima Domain' />
      <Div className="col-md-12">
        <Div className="page-header-toolbar">

          <Div className="btn-group toolbar-item" role="group" >
            <Input type="text" name="email" id="email" onChange={handleSearchDomain} />
          </Div>

          {role === 'SALESC' ? <Div>
            <FormButton style={{ marginLeft: '12px' }} onClick={() => setAddDomain(true)}
              className="btn btn-primary submit-btn btn-block">
              Add Axima Domain</FormButton>
          </Div> : null}

        </Div>
      </Div>

      <Div className="col-md-12 margin_top">
        {currentItems ? <table className="table" border="1">
          <thead>
            <tr>
              <th>Domain Name</th>
              <th>Company Name</th>
              <th>Time
                {/* <button onClick={sortData} variant="primary">
                                    <span className="ml-2">
                                        {isAscending ? '↓' : '↑'}
                                    </span>
                                </button> */}
              </th>
              {/* {role === 'SALESC' &&
                <th>Action
                </th>
              } */}
              {/* {role === 'ADEPLOY' && <th>Status</th>} */}
            </tr>
          </thead>
          <tbody id="tableBody">
            {currentItems.map((domain) =>

              <tr key={domain.axima_subscription_id}>
                <td><button onClick={() => handleDomainClick(domain.domain_id, domain.domain_name)} className="btn btn-link ">{domain.domain_name}</button></td>
                <td>{domain.companyName}</td>
                <td>{domain.timestamp}</td>
                {/* {role === 'SALESC' && <td>
                  {renderActionButtons(domain.axima_subscription_id, domain.domain_name)}
                </td>} */}
                {/* {role === 'ADEPLOY' && <td>
                  <Select name='status' options={status} defaultValue="Select Status"
                    // onChange={(e) => handleUpdateSegmentSelect(e.target.value)}
                    style={{ width: 'auto' }} />
                  <Div className="d-flex gap-2 mt-2">
                    <FormButton
                      className="btn btn-primary btn-sm"
                      onClick={() => handleUpdateStatus(domain.doamin_id)}
                    >
                      Update
                    </FormButton>
                  </Div>
                </td>} */}
              </tr>
            )

            }
          </tbody>
        </table> :
          <>
            <p style={{ marginTop: '30px' }}>Not Domain Present or Could not fetch Domains</p>
          </>}

        {domainList.length > 0 ?
          <Stack spacing={2}>
            <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate}>

            </Pagination>

          </Stack> : null
        }
      </Div>

    </>
  )
}